export default __webpack_public_path__ + "static/media/chevron-left.a5b61ce3.svg";